// Checkout Forms
import { FIRST_NAME_DATA_STANDARDS, LAST_NAME_DATA_STANDARDS } from 'checkout-forms/form/fields';
import getAddressFieldsConfig from 'checkout-forms/form/configs/address';

// Config
import getInternationalPhoneNumberConfig from '@utils/lazy/internationalPhoneNumberConfig';

// eslint-disable-next-line no-misleading-character-class
const invalidApplePayNameCharactersRegex = /[\p{Extended_Pictographic}\uFE0F\u200D\u{1D400}-\u{1D7FF}]/u;

export const validateApplePayNameCharacters = (value, validationMessageKeys) => {
  if (invalidApplePayNameCharactersRegex.test(value)) {
    return validationMessageKeys.regex;
  }

  return undefined;
};

export const withApplePayNameValidation = (field) => ({
  ...field,
  validationFnc: validateApplePayNameCharacters,
});

export const FIRST_NAME_APPLE_PAY = withApplePayNameValidation(FIRST_NAME_DATA_STANDARDS);
export const LAST_NAME_APPLE_PAY = withApplePayNameValidation(LAST_NAME_DATA_STANDARDS);

export const APPLE_PAY_BILLING_ADDRESS_FORM_ID = 'applePayBillingDetailsForm';
export default function getApplePayBillingDetailsFormConfig(params) {
  const { countryCode, addressLines, maxAddressLines, actions, configExtras } = params;

  const { isClickCollectOrder, submitButtonExtra } = configExtras;

  const ADDRESS_FIELDS = getAddressFieldsConfig({
    countryCode,
    addressLines,
    maxAddressLines,
    actions,
    configExtras,
    allowAsciiOnly: true,
  });

  const PHONE_NUMBER = getInternationalPhoneNumberConfig({
    isClickCollectOrder,
    showDefaultInstruction: true,
  });

  return {
    submitButton: 'Continue with payment',
    submitButtonExtra,
    id: APPLE_PAY_BILLING_ADDRESS_FORM_ID,
    fields: [FIRST_NAME_APPLE_PAY, LAST_NAME_APPLE_PAY, PHONE_NUMBER, ...ADDRESS_FIELDS],
  };
}
